import React, { createContext, useContext } from "react";
import { noop } from "@litres/utils";

interface IMenuContext {
  setContextMenuHidden: React.Dispatch<React.SetStateAction<boolean>>;
  setContextMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
interface IContextMenuProvider extends IMenuContext {
  children: React.ReactNode;
}
const defaultContext = {
  setContextMenuHidden: noop,
  setContextMenuOpen: noop,
};
const MenuContext = createContext<IMenuContext>(defaultContext);

export const useMenuContext = () => useContext(MenuContext);

export const ContextMenuProvider = ({
  children,
  ...value
}: IContextMenuProvider) => (
  <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
);
